export const fullscreenIconContent = `<path d="M13.5 0.5H9V1.5H11.7928L7.64642 5.64642L8.35353 6.35353L12.5 2.20706V5H13.5V0.5Z" fill="currentColor"/>
<path d="M5.64642 7.64642L1.5 11.7928V9H0.5V13.5H5V12.5H2.20706L6.35353 8.35353L5.64642 7.64642Z" fill="currentColor"/>`
